import { render, staticRenderFns } from "./money.vue?vue&type=template&id=019dcb1b&"
import script from "./money.vue?vue&type=script&lang=js&"
export * from "./money.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('019dcb1b')) {
      api.createRecord('019dcb1b', component.options)
    } else {
      api.reload('019dcb1b', component.options)
    }
    module.hot.accept("./money.vue?vue&type=template&id=019dcb1b&", function () {
      api.rerender('019dcb1b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/form-fields/money.vue"
export default component.exports